import GithubSlugger from 'github-slugger';

/** Help article TOC: ATX # / ## / ### only; ids match `rehype-slug` (GitHub-style). */

export type HelpArticleSection = { id: string; title: string };

const HEADING_LINE = /^#{1,3}\s+(.+?)(?:\s+#*)?\s*$/;

/**
 * Parse markdown source (not HTML) for headings. Order matches react-markdown + rehype-slug.
 * Use plain heading text when possible; inline markup in the heading line can diverge from slugged DOM ids.
 */
export function sectionsFromMarkdown(content: string | null | undefined): HelpArticleSection[] {
    if (content == null || !String(content).trim()) {
        return [];
    }
    const slugger = new GithubSlugger();
    const sections: HelpArticleSection[] = [];
    for (const line of String(content).replace(/\r\n/g, '\n').split('\n')) {
        const m = HEADING_LINE.exec(line);
        const titleLine = m?.[1];
        if (titleLine == null) {
            continue;
        }
        const rawTitle = titleLine.trim().replace(/#+$/g, '').trim();
        if (!rawTitle) {
            continue;
        }
        const id = slugger.slug(rawTitle);
        sections.push({ id, title: rawTitle });
    }
    return sections;
}
